import '@/js/services/backdrop'
import '@/js/services/mobilemenu'
import '@/js/services/toplineusermenu'
import '@/js/services/autoresize-textarea'

import Dialog from '@/js/components/Dialog'
import DialogLogin from '@/js/components/DialogLogin'
import DialogRegister from '@/js/components/DialogRegister'
import DialogForgotPassword from '@/js/components/DialogForgotPassword'
import DialogForgotPasswordMailSuccess from '@/js/components/DialogForgotPasswordMailSuccess'
import DialogResetPassword from '@/js/components/DialogResetPassword'
import DialogResetPasswordSuccess from '@/js/components/DialogResetPasswordSuccess'

import AboutPage from '@/js/pages/AboutPage'

class App {
    pages = {
        about: AboutPage,
    }

    constructor() {
        const pageKey = document.body.dataset.page

        // Dialogs
        this.initDialogs()

        // Pages
        if (pageKey) {
            const page = this.pages[pageKey]
            if (typeof page === 'function') {
                new page()
            }
        }

        // Открываем диалог по хэшу
        const hash = location.hash.substring(1)
        if (hash && ['login', 'register'].includes(hash) && !('isAuth' in document.body.dataset)) {
            Dialog.show(hash)
        }

        const url = new URL(document.location)
        if (url.searchParams.has('reset-password-token')) {
            Dialog.show('reset-password')
        }
    }

    initDialogs() {
        if ('isAuth' in document.body.dataset) {
            // add js logic for auth users if needed
        } else {
            new DialogLogin()
            new DialogRegister()
            new DialogForgotPassword()
            new DialogForgotPasswordMailSuccess()
        }

        new DialogResetPassword()
        new DialogResetPasswordSuccess()

        document.addEventListener('click', e => {
            const button = e.target.closest('[data-dialog]')

            if (!button) {
                return
            }

            e.preventDefault()
            Dialog.show(button.dataset.dialog, { target: button })
        })

        document.addEventListener('click', e => {
            const button = e.target.closest('[data-dialog-close]')

            if (!button) {
                return
            }

            e.preventDefault()
            Dialog.hide()
        })
    }
}

new App()

